const getHost = () => {
  const url = new URL(window.location.href);
  return `${url.protocol}//${url.host}/`; // href
};

export { getHost };
